// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { BaseEntity } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/BaseEntity';
import { UserSetting } from './UserSetting';
import { Tenancy } from './Tenancy';
/**
 * 用户 实体类
 * 模型驱动的用户，可以是个人也可以是组织
 */
export class User extends BaseEntity {
  /** 昵称 : 昵称 */
  private _nickname: string;

  /** 设置：昵称 */
  public get nickname() {
    return this._nickname;
  }

  /** 获取：昵称 */
  public set nickname(value: string) {
    this._nickname = value;
  }

  /** 登录账户ID : 登录账户ID */
  private _loginAccountId: string;

  /** 设置：登录账户ID */
  public get loginAccountId() {
    return this._loginAccountId;
  }

  /** 获取：登录账户ID */
  public set loginAccountId(value: string) {
    this._loginAccountId = value;
  }

  /** 是否是主用户 : 是否是主用户，个人用户都是主用户，机构用户只有一个主用户，主用户即机构的管理者 */
  private _isMain: boolean;

  /** 设置：是否是主用户 */
  public get isMain() {
    return this._isMain;
  }

  /** 获取：是否是主用户 */
  public set isMain(value: boolean) {
    this._isMain = value;
  }

  /** 用户设置 */
  private _userSettings: Array<UserSetting>;

  /** 获取：用户设置 */
  public get userSettings() {
    return this._userSettings;
  }

  /** 设置：用户设置 */
  public set userSettings(value: Array<UserSetting>) {
    this._userSettings = value;
  }

  /** 租户 的ID */
  private _tenancy_ID: string;

  /** 获取：租户 的ID */
  public get tenancy_ID() {
    return this._tenancy_ID;
  }

  /** 设置：租户 的ID */
  public set tenancy_ID(value: string) {
    this._tenancy_ID = value;
  }

  /** 租户  */
  private _tenancy: Tenancy;

  /** 获取：租户  */
  public get tenancy() {
    return this._tenancy;
  }

  /** 设置：租户  */
  public set tenancy(value: Tenancy) {
    this._tenancy = value;
    if (value !== null) {
      this.tenancy_ID = value.id;
    } else {
      this.tenancy_ID = '';
    }
  }

  constructor() {
    super();
    this._nickname = '';
    this._loginAccountId = '';
    this._isMain = false;
    this._userSettings = new Array<UserSetting>();
    this._tenancy_ID = '';
    this._tenancy = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: User, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.nickname = element.nickname;
      this.loginAccountId = element.loginAccountId;
      this.isMain = element.isMain;
      this.tenancy_ID = element.tenancy_ID;
      if (hasReference && element.tenancy !== null) {
        this.tenancy = element.tenancy;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.nickname = json.Nickname;
    this.loginAccountId = json.LoginAccountId;
    this.isMain = json.IsMain;
    if (json.UserSettings && json.UserSettings.length > 0) {
      json.UserSettings.forEach((element: any) => {
        const userSetting = UserSetting.Create(element);
        // userSetting.user = this;
        this.userSettings.push(userSetting);
      });
    }
    this.tenancy_ID = json.Tenancy_ID;
    // if (json.Tenancy !== null) {
    //   this.tenancy = Tenancy.Create(json.Tenancy);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.Nickname = this.nickname;
    json.LoginAccountId = this.loginAccountId;
    json.IsMain = this.isMain;
    if (this.userSettings && this.userSettings.length > 0) {
      json.UserSettings = [];
      this.userSettings.forEach((element) => {
        json.UserSettings.push(element.toJson());
      });
    }
    json.Tenancy_ID = this.tenancy_ID;
  }

  static Create(json: any): User {
    const user = new User();
    user.Deserialize(json);
    user.json = json;
    return user;
  }
}
